import React, {useEffect} from 'react'

//Mostly for testing Sentry error reporting and source maps.
const GenerateTestErrorPage: React.FC<{}> = () => {
  useEffect(() => {
    const triggerError = () => {
      try {
        // Intentionally cause an error.
        // The error can be made more complex if needed, to test specific scenarios.
        // For example, calling a non-existent function:
        // (window as any).nonExistentFunction();
        throw new Error('Sentry Test Error: Successfully generated from /meta/generate_test_error! 🎉')
      } catch (e) {
        // 'e' is 'unknown' if 'useUnknownInCatchVariables' is true in tsconfig (common in strict mode),
        // otherwise it's 'any'. For re-throwing, this distinction is less critical here.
        // While Sentry's global error handler should catch unhandled exceptions,
        // explicitly capturing it can be useful for more control or adding tags.
        // However, for basic source map testing, just letting it bubble up is often enough.
        // if (Sentry && typeof Sentry.captureException === 'function') {
        //   Sentry.captureException(e); // If Sentry was imported, pass the caught error
        // }
        // For this test, we'll re-throw to ensure it's unhandled by this component
        // and caught by Sentry's global handlers.
        console.error('Deliberately throwing test error:', e)
        throw e
      }
    }

    // Trigger the error shortly after the component mounts.
    // A small timeout can sometimes help ensure Sentry is fully ready,
    // though usually not strictly necessary if Sentry is initialized early.
    // window.setTimeout returns a number in browser environments.
    const timerId: number = window.setTimeout(triggerError, 100)

    // Cleanup timeout on unmount. The return function from useEffect should return void or undefined.
    return () => {
      window.clearTimeout(timerId)
    }
  }, []) // Empty dependency array means this effect runs once on mount.

  return (
    <div>
      <h1>Generating Test Error...</h1>
      <p>If you see this page, an error should have been thrown and reported to Sentry.</p>
      <p>Check your Sentry dashboard.</p>
    </div>
  )
}

export default GenerateTestErrorPage
